import React from 'react'
import { Route, Switch } from 'wouter'

import { AddOrder } from './multi-order-invoice/add-order'
import { DelayedOrders } from './delays'
import { GroupOrderPreparation } from './order_preparation'
import { ListInvoices } from './multi-order-invoice/list-invoices'
import { OrderEdit } from './order_edit'
import { ViewInvoice } from './multi-order-invoice/view-invoice'

export function OrdersGroup() {
  return (
    <div>
      <Switch>
        <Route path="/orders/delays">
          <DelayedOrders />
        </Route>
        <Route path="/orders/preparation-group">
          <GroupOrderPreparation />
        </Route>
        <Route path="/orders/:id/edit">
          {(params) => <OrderEdit id={params.id} />}
        </Route>
        <Route path="/orders/multi-order-invoice">
          <ListInvoices />
        </Route>
        <Route path="/orders/multi-order-invoice/:id">
          {(params) => <ViewInvoice id={parseInt(params.id)} />}
        </Route>
        <Route path="/orders/multi-order-invoice/:id/new">
          {(params) => <AddOrder id={parseInt(params.id)} />}
        </Route>
      </Switch>
    </div>
  )
}
